import { render, staticRenderFns } from "./ComplieHeaderArvhiveViewMenu.vue?vue&type=template&id=72c70c50&scoped=true"
import script from "./ComplieHeaderArvhiveViewMenu.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderArvhiveViewMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderArvhiveViewMenu.vue?vue&type=style&index=0&id=72c70c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c70c50",
  null
  
)

export default component.exports